var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agree-policy"},[(_vm.showStatement)?_c('Agreement',{attrs:{"policyInfo":_vm.policyInfo,"showSystemPolicy":_vm.showSystemPolicy,"isApplicationAgreement":_vm.isApplicationAgreement,"isTalentAgreement":_vm.isTalentAgreement},on:{"submit":_vm.handleSubmit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }